import { useAtom } from 'jotai';
import { state } from '~/storage';

export function useDialogs() {
	const [dialogs, setOpenDialog] = useAtom(state.dialogs);

	return {
		isDialogOpen: (dialogName: keyof typeof dialogs) => dialogs[dialogName],
		openDialog: (dialogName: keyof typeof dialogs) => setOpenDialog({ ...dialogs, [dialogName]: true }),
		closeDialog: (dialogName: keyof typeof dialogs) => setOpenDialog({ ...dialogs, [dialogName]: false }),
	};
}
